export function preventDefault (fn) {
  // can be used directly as event handler
  if (fn.preventDefault && fn.stopPropagation) {
    const event = fn
    event.preventDefault()
    event.stopPropagation()
  }

  return (event, ...args) => {
    event && event.preventDefault()
    event && event.stopPropagation()
    if (typeof fn !== 'function') return
    return fn(event, ...args)
  }
}

export function stopPropagation (event) {
  if (!event || !event.stopPropagation) return
  event.preventDefault()
  event.stopPropagation()
}



// WEBPACK FOOTER //
// ./src/utils/events.js